import { Area } from '@backoffice-frontend/area-components'
import { AuthenticatedAppViewAreaId } from '../../AuthenticatedAppViewAreaId'
import { AccountView } from './AccountView'

export const AccountViewArea = () => (
  <Area id={AuthenticatedAppViewAreaId}>
    <AccountView />
  </Area>
)
